export const actionTypes = {
    SET_CURRENT_CALENDAR_EVENT: 'SET_CURRENT_CALENDAR_EVENT',
    GET_CURRENT_CALENDAR_EVENT: 'GET_CURRENT_CALENDAR_EVENT',
    SET_CALENDAR_EVENT_TO_ADD: 'SET_CALENDAR_EVENT_TO_ADD',
    GET_CALENDAR_EVENT_TO_ADD: 'GET_CALENDAR_EVENT_TO_ADD',
    FIND_BY_TITLE: 'FIND_BY_TITLE',
    FIND_BY_TITLE_SUCCESSFUL: 'FIND_BY_TITLE_SUCCESSFUL',
    SET_SEARCH_TITLE: 'SET_SEARCH_TITLE',
    GET_SEARCH_TITLE: 'GET_SEARCH_TITLE',
    SET_CURRENT_INDEX: 'SET_CURRENT_INDEX',
    GET_CURRENT_INDEX: 'GET_CURRENT_INDEX',
    SET_MESSAGE: 'SET_MESSAGE',
    GET_MESSAGE: 'GET_MESSAGE',
    SET_SUBMITTED: 'SET_SUBMITTED',
    GET_SUBMITTED: 'GET_SUBMITTED',
    GET_IS_LOADING: 'GET_IS_LOADING',
    SET_IS_LOADING: 'SET_IS_LOADING',
    GET_IS_FINDING: 'GET_IS_FINDING',
    SET_IS_FINDING: 'SET_IS_FINDING',
    SET_CALENDAR_EVENTS: 'SET_CALENDAR_EVENTS',
    GET_CALENDAR_EVENTS: 'GET_CALENDAR_EVENTS',
    GET_CALENDAR_EVENTS_SUCCESSFUL: 'GET_CALENDAR_EVENTS_SUCCESSFUL',
    GET_CALENDAR_EVENT: 'GET_CALENDAR_EVENT',
    GET_CALENDAR_EVENT_SUCCESSFUL: 'GET_CALENDAR_EVENT_SUCCESSFUL',
    ADD_CALENDAR_EVENT: 'ADD_CALENDAR_EVENT',
    ADD_CALENDAR_EVENT_SUCCESSFUL: 'ADD_CALENDAR_EVENT_SUCCESSFUL',
    UPDATE_CALENDAR_EVENT: 'UPDATE_CALENDAR_EVENT',
    UPDATE_CALENDAR_EVENT_SUCCESSFUL: 'UPDATE_CALENDAR_EVENT_SUCCESSFUL',
    DELETE_CALENDAR_EVENT: 'DELETE_CALENDAR_EVENT',
    DELETE_CALENDAR_EVENT_SUCCESSFUL: 'DELETE_CALENDAR_EVENT_SUCCESSFUL',
    DELETE_CALENDAR_EVENTS: 'DELETE_CALENDAR_EVENTS',
    DELETE_CALENDAR_EVENTS_SUCCESSFUL: 'DELETE_CALENDAR_EVENTS_SUCCESSFUL',
    API_ERRORED: 'API_ERRORED',
    IS_FETCHING: 'IS_FETCHING',
    IS_UPDATING: 'IS_UPDATING',
    IS_DELETING: 'IS_DELETING',
    IS_DELETING_ALL: 'IS_DELETING_ALL',
    IS_ADDING: 'IS_ADDING',
    IS_FINDING: 'IS_FINDING',
    IS_LOADING: 'IS_LOADING',
};